export enum AmplitudeDomain {
    Time = 0,
    Depth = 1,
    Unknown = 2,
    Others = 10,
}